






















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component
export default class InquiryItem extends Vue {
  // 修正画面かどうか
  fix = false;
  // 初期化済みかどうか
  is_initialized = false;
  // inquiry_type
  inquiry_type = '';
  // 質問
  inquiries = [];
  inquiry: any = {};
  // 回答一覧
  answers: any = {};
  // 回答
  answer: number | null = null;
  // ページ番号
  page_num = 1;

  // 選択肢
  choices_type4: any[] = [];
  choices_type7 = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' }
  ];

  // 未選択時エラーメッセージ
  error_message = '';

  async setChoicesType4(inquiry: any): Promise<any> {
    this.choices_type4 = [];
    const choices: any[] = [];
    const selection = inquiry.selection;
    Object.keys(inquiry.selection).forEach(function(index) {
      choices.push({
        value: index,
        label: selection[index]
      });
    });
    this.choices_type4 = choices;
  }

  async setInitialValue(): Promise<any> {
    if (this.inquiry.id in this.answers) {
      this.answer = this.answers[this.inquiry.id];
    } else {
      this.answer = null;
    }
    setTimeout(() => {
      this.is_initialized = true;
    }, 500);
  }

  @Watch('answer', { immediate: false })
  onAnswerChanged(): void {
    if (this.is_initialized) {
      setTimeout(() => {
        if (this.fix) {
          this.fixAnswer(true, this.inquiry);
        } else {
          this.next(this.inquiry);
        }
      }, 500);
    }
    this.is_initialized = true;
  }

  count(): string {
    // textの場合は表示しない
    if (this.inquiry.answer_type == 8) return '';

    let text_page_count = 0;
    const page_num = this.page_num;
    this.inquiries.forEach(function(value: any, key: any) {
      if (key < page_num && value.answer_type == 8) {
        text_page_count = text_page_count + 1;
      }
    });
    return (
      '(' +
      (this.page_num - text_page_count) +
      '/' +
      (this.inquiries.length - 3) +
      ')'
    );
  }

  // 前の質問
  async back(): Promise<any> {
    // 前の質問へ
    if (this.page_num >= 2) {
      this.$router.push(
        '/inquiry/' + this.inquiry_type + '/' + (this.page_num - 1)
      );
    }
  }

  // 次の質問または確認画面へ
  async next(inquiry: any): Promise<any> {
    this.toggleLoading({ is_loading: true, time: 0 });

    if (inquiry.answer_type != 8) {
      if (this.answer == null) {
        this.toggleLoading({ is_loading: false, time: 1 });
        this.$toasted.error('未選択項目があります', {
          duration: 3000,
          position: 'top-center'
        });
        return;
      }

      this.answers[inquiry.id] = this.answer;
      this.$store.commit('answer/setAnswers', this.answers);
    }

    if (this.page_num < this.inquiries.length) {
      this.$router.push(
        '/inquiry/' + this.inquiry_type + '/' + (this.page_num + 1)
      );
    } else {
      this.$router.push('/inquiry/' + this.inquiry_type + '/confirm');
    }
  }

  // 回答修正
  async fixAnswer(isUpdate: boolean, inquiry: any): Promise<any> {
    this.toggleLoading({ is_loading: true, time: 0 });

    if (isUpdate && inquiry.answer_type != 8) {
      if (this.answer == null) {
        this.toggleLoading({ is_loading: false, time: 1 });
        this.$toasted.error('未選択項目があります', {
          duration: 3000,
          position: 'top-center'
        });
        return;
      }

      this.answers[inquiry.id] = this.answer;
      this.$store.commit('answer/setAnswers', this.answers);
    }

    this.$router.push('/inquiry/' + this.inquiry_type + '/confirm');
  }

  created(): void {
    this.fix = this.$route.query.fix == '1';
  }

  // Loadingの表示，非表示の制御
  toggleLoading(params: { is_loading: boolean; time: number }): void {
    this.$emit('toggleLoading', params);
  }

  // 変数や初期表示値の設定
  async mounted(): Promise<any> {
    this.toggleLoading({ is_loading: true, time: 0 });

    this.inquiry_type = this.$route.params.inquiry_type;
    this.page_num = Number(this.$route.params.id);

    if (
      this.inquiry_type != 'PRC' &&
      this.inquiry_type != 'FRC' &&
      this.inquiry_type != 'CRC'
    ) {
      this.$toasted.error('不正なリクエストです', {
        duration: 2000,
        position: 'top-center'
      });
      this.$router.push('/');
    }

    const inquiries = await this.$store.state.question.questions;
    this.inquiries = inquiries[0].questions;
    this.inquiry = this.inquiries[this.page_num - 1];

    if (this.page_num <= 0 && this.page_num >= inquiries.length + 1) {
      this.$toasted.error('不正なリクエストです', {
        duration: 2000,
        position: 'top-center'
      });
      this.$router.push('/');
    }

    this.answers = await this.$store.state.answer.answers;

    if (this.inquiry.answer_type == 4) {
      await this.setChoicesType4(this.inquiry);
    }

    await this.setInitialValue();

    window.scrollTo(0, 0);
    this.toggleLoading({ is_loading: false, time: 0.5 });
  }
}
